import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-61d932b0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "carousel"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  class: "banner-buttons"
};
const _hoisted_6 = {
  class: "concat-bar"
};
export default {
  __name: 'index',
  props: {
    list: Array
  },
  setup(__props) {
    const props = __props;
    const basePath = window.appConfig.VUE_APP_PATH;
    // 轮播图

    const goPage = item => {
      window.open(item.link, '_blank');
    };
    const handlerStyle = item => {
      return {
        'background-image': `url("${item.imgSrc}")`
      };
    };
    return (_ctx, _cache) => {
      const _component_a_carousel = _resolveComponent("a-carousel");
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_carousel, {
        class: "banner",
        effect: "fade",
        autoplay: true
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.list, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: index
          }, [_createElementVNode("div", {
            class: "banner-item",
            style: _normalizeStyle(handlerStyle(item))
          }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
            class: "banner-title",
            innerHTML: item.head
          }, null, 8, _hoisted_3), _createElementVNode("div", {
            class: "banner-description",
            innerHTML: item.desc
          }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, [_renderSlot(_ctx.$slots, "default")])])], 4)]);
        }), 128))]),
        _: 3
      })]), _createElementVNode("div", _hoisted_6, [_createTextVNode(" 一键开启亲笔签之旅 "), _createVNode(_component_router_link, {
        to: _unref(basePath),
        class: "h-logo"
      }, {
        default: _withCtx(() => [_createTextVNode("联系我们")]),
        _: 1
      }, 8, ["to"])])], 64);
    };
  }
};